export default {
  operator: 'Operator',
  user: 'User',
  value: 'Value',
  date: 'Date',
  operators: 'Operators',
  status: 'Status',
  users: 'Users',
  export: 'Export as XLSX',
  infoLabel: 'Component Information',
  filterLabel: 'Apply filter',
  trashLabel: 'Clear filter',
  closeLabel: 'Close information',
  statusLabel: 'Status',
  openOperatorLabel: 'Open operator conversations',
  viewChat: 'View conversations',
  faq: [
    {
      title: 'What is it?',
      description: 'Operator status table in Smart Care for activity monitoring.',
    },
    {
      title: 'How to change the Operator?',
      description: 'To change the filter, click on the "Operators" field, select the desired Operators, and click on the "filter" icon at the top right of the table. Only the notes of the selected operators will be displayed.',
    },
    {
      title: 'How to filter by operator status?',
      description: 'To filter by status, click on the "Operator Status" field, select whether you want to filter only "ONLINE" or "OFFLINE" operators.',
    },
    {
      title: 'How to reset the filter?',
      description: 'To reset the filter, click on the "trash" icon below the "filter" icon, and all filters in the table will be reset to the default.',
    },
  ],
  username: 'User name',
  lastStatus: 'Last status',
  offlineText: 'Offline',
  onlineText: 'Online',
};
